/**
 * 输入时去掉 emoji（表情、国旗、肤色、ZWJ 组合、按键帽）。
 *
 * 用 ES2015 `u` 旗标的码位区间，不用 `\p{Extended_Pictographic}`：
 * 旧 WebView 的 Unicode 属性表停在出厂版本，新表情会漏；区间不看系统字库。
 * `u` 旗标：iOS 10+ / Chrome 50+ / 同等 Android WebView。
 * 单字符类一次 replace，线性扫描，无回溯。
 *
 * 补充平面 1F000–1FFFF 没有开户会用到的汉字、字母、数字。
 * BMP 只收表情呈现用的符号区，避免误伤中文标点和全角字符。
 */
const EMOJI_RE =
  /[\u200D\uFE0E\uFE0F\u20E3\u{2300}-\u{23FF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{1F000}-\u{1FFFF}\u{E0020}-\u{E007F}]/gu;

export function stripEmoji(value: string): string {
  return value.replace(EMOJI_RE, '');
}
